<template>
    <div id="comment" class="des rel">
        <div class="g_t over alR">
            <div class="left fB">
                <em class="red">2F</em>
                    用户评论<em class="gray pl10">COMMENT</em>
            </div>
        </div>
        <ul id="whatchoose" class="u_q clearfix n_comment">
            <li :class="bian==0?'lang':'lang1'" @click="quan()" data-id="0" data-t="320">全部({{shopInfo.length}})</li>
            <!-- ({{talk_num}}) -->
            <!-- <li :class="bian==1?'lang':'lang1'" @click="you()" data-id="0" data-t="320">有图({{shu}})</li>
            <li :class="bian==2?'lang':'lang1'" @click="wu()" data-id="0" data-t="320">无图({{shu1}})</li> -->
        </ul>
        <p class="lh30">&nbsp;</p>
        <div class="over" id="wpl" v-if="talk_num > 0">
            <div v-if="bian==0">
                <div class="ucom" v-for="(item,index) in dataShow" :key="index" >
                    <div class="ucoml">
                        <p>
                            <!-- <img :src="$fnc.getImgUrl(oneTalk.avatar,'sex')" class="omg"> -->
                            <!-- <img src="../../assets/image/addimg.png" class="hg" alt=""> -->
                            <img :src="$fnc.getImgUrl(item.avatar,'sex')" class="omg">
                        </p>
                    </div>
                        <div class="ucomr">
                        <p class="lcor">◆</p>
                        <div class="ov">
                            <em class="left">{{item.nickname?item.nickname[0] : ''}}<small>**</small></em>
                            <em class="vip">{{item.rating_cn}}</em>
                            <i class="right c9"></i>
                        </div>
                        <p class="f14">{{item.content}}</p>
                        <!-- <div class="s_d">
                            <img src="../../assets/picture/product/5da968731cd24.png">
                            <img src="../../assets/picture/product/5da96873229ae.png">
                            <div class="s_db"></div>
                        </div> -->
                    </div>
                    <div v-if="item.piclink && item.piclink.length>0">
                        <div v-for="(it,i) in item.piclink" :key="i" >
                            <img :src="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" :imgurl="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" alt style="width:180px;border-radius: 4px;">
                        </div>
                    </div>
                </div>
                <div class="fen">
                    <input type="button" value="上一页" @click="prePage" class="input1">
                    <!-- <span v-for="(i,index) in pageNum" :key="index" @click="page(i)" class="span1">{{ i }}</span> -->
                    <input type="button" value="下一页" @click="nextPage" class="input1">
                </div>
            </div>
            <div v-if="bian==1">
                <div class="ucom" v-for="(item,index) in dataShow1" :key="index" >
                    <div class="ucoml">
                        <p>
                            <img :src="$fnc.getImgUrl(item.avatar,'sex')" class="omg">
                        </p>
                    </div>
                        <div class="ucomr">
                        <p class="lcor">◆</p>
                        <div class="ov">
                            <em class="left">{{item.nickname?item.nickname[0] : ''}}<small>**</small></em>
                            <em class="vip">{{item.rating_cn}}</em>
                            <i class="right c9"></i>
                        </div>
                        <p class="f14">{{item.content}}</p>
                    </div>
                    <div v-if="item.piclink && item.piclink.length>0">
                        <div v-for="(it,i) in item.piclink" :key="i" >
                            <img :src="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" :imgurl="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" alt style="width:180px;border-radius: 4px;">
                        </div>
                    </div>
                </div>
                <div class="fen">
                    <input type="button" value="上一页" @click="prePage1" class="input1">
                    <!-- <span v-for="(i,index) in pageNum1" :key="index" @click="page1(i)" class="span1">{{ i }}</span> -->
                    <input type="button" value="下一页" @click="nextPage1" class="input1">
                </div>
            </div>
            <div v-if="bian==2">
                <div class="ucom" v-for="(item,index) in list1" :key="index" >
                    <div class="ucoml">
                        <p>
                            <img :src="$fnc.getImgUrl(item.avatar,'sex')" class="omg">
                        </p>
                    </div>
                        <div class="ucomr">
                        <p class="lcor">◆</p>
                        <div class="ov">
                            <em class="left">{{item.nickname?item.nickname[0] : ''}}<small>**</small></em>
                            <em class="vip">{{item.rating_cn}}</em>
                            <i class="right c9"></i>
                        </div>
                        <p class="f14">{{item.content}}</p>
                    </div>
                    <div v-if="item.piclink && item.piclink.length>0">
                        <div v-for="(it,i) in item.piclink" :key="i" >
                            <img :src="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" :imgurl="'https://www.yeying360.com'+$fnc.getImgUrl(it.piclink)" alt style="width:180px;border-radius: 4px;">
                        </div>
                    </div>
                </div>
                <div class="fen">
                    <input type="button" value="上一页" @click="prePage2" class="input1">
                    <!-- <span v-for="(i,index) in pageNum2" :key="index" @click="page2(i)" class="span1">{{ i }}</span> -->
                    <input type="button" value="下一页" @click="nextPage2" class="input1">
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="over" id="wpl" v-else>
            暂无评论
        </div>
        <div id="pager" class="page alC"></div>
    </div>
</template>

<script>
export default {
    props:{
        oneTalk:{
            type:Object,
            default:()=>{}
        },
        talk_num:null
    },
    data(){
        return{ 
            shopInfo:[],
            shu:'',
            shu1:'',
            bian:0,
            list:[],
            list1:[],

            array:[],

            // 产品id
            ai:'',
            page11: {
                    num: 1, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
                    // size: 10 //每页数据条数,默认10
                    num1:1,
                },

            totalPage: [], // 所有分页的数据
            pageSize: 10, // 每页显示数量
            pageNum: 1,  // 共几页=所有数据/每页现实数量     
            dataShow: [], // 当前显示的数据  
            currentPage: 0, // 默认当前显示第一页

            totalPage1: [], // 所有分页的数据
            pageSize1: 10, // 每页显示数量
            pageNum1: 1,  // 共几页=所有数据/每页现实数量     
            dataShow1: [], // 当前显示的数据  
            currentPage1: 0, // 默认当前显示第一页

            totalPage2: [], // 所有分页的数据
            pageSize2: 10, // 每页显示数量
            pageNum2: 1,  // 共几页=所有数据/每页现实数量     
            dataShow2: [], // 当前显示的数据  
            currentPage2: 0 // 默认当前显示第一页
        }
    },
    created(){
        this.getShopDetails(this.$route.query.id)
    },
    methods:{
        // 下一页
        nextPage() {
            // if (this.currentPage === this.pageNum - 1) return ;
            // this.dataShow = this.totalPage[++this.currentPage];
            
            if(this.shopInfo.length == 10){
                this.page11.num++;
                this.getShopDetails(this.ai);
            } else{
                this.page11.num;
                this.getShopDetails(this.ai);
            }
            // console.log(this.page11.num) 
        },
        // 上一页
        prePage() {
            // if (this.currentPage === 0) return ;
            // this.dataShow = this.totalPage[--this.currentPage];
            // console.log(this.page11.num)
            if(this.page11.num > 1){
                this.page11.num--;
                this.getShopDetails(this.ai);
            } else{
                this.page11.num;
                this.getShopDetails(this.ai);
            }
        },
        // 点击页码
        // page(i){
        //     this.currentPage = i
        //     this.dataShow = this.totalPage[i-1];
        // },

        // 下一页
        // nextPage1() {
        //     // if (this.currentPage1 === this.pageNum1 - 1) return ;
        //     // this.dataShow1 = this.totalPage1[++this.currentPage1];
        //     this.page11.num++;
        //     this.getShopDetails(392);
        // },
        // 上一页
        // prePage1() {
        //     // if (this.currentPage1 === 0) return ;
        //     // this.dataShow1 = this.totalPage1[--this.currentPage1];
        //     this.page11.num--;
        //     this.getShopDetails(392);
        // },
        // 点击页码
        // page1(i){
        //     this.currentPage1 = i
        //     this.dataShow1 = this.totalPage1[i-1];
        // },

        // 下一页
        // nextPage2() {
        //     // if (this.currentPage2 === this.pageNum2 - 1) return ;
        //     // this.dataShow2 = this.totalPage2[++this.currentPage2];
        //     this.page11.num++;
        //     this.getShopDetails(392);
        // },
        // 上一页
        // prePage2() {
        //     // if (this.currentPage2 === 0) return ;
        //     // this.dataShow2 = this.totalPage2[--this.currentPage2];
        //     this.page11.num--;
        //     this.getShopDetails(392);
        // },
        // 点击页码
        // page2(i){
        //     this.currentPage2 = i
        //     this.dataShow2 = this.totalPage2[i-1];
        // },

        quan(){
            this.bian = 0
        },
        you(){
            this.bian = 1
        },
        wu(){
            this.bian = 2
        },
         //获取数据
        getShopDetails(id) {
            // var that = this;
            var params = {};
            params.page = this.page11.num;
            // console.log(params.page)
            // console.log(params) 
            params.id = id || "";
            this.ai = params.id;
            // console.log(this.ai)
            this.$api.getShop.getShopDetails1(params).then(res => {
                if (res.code == 200) {
                    // console.log(res)
                    let arr = res.result;
                    // this.shopInfo = res.result;
                    // console.log(arr)
                    // 如果是第一页需手动置空列表
                    this.shopInfo = [];
                    if (params.page === 1) 
                        this.shopInfo = [];
                        // 把请求到的数据添加到列表
                        // for(let i=0;i<5;i++){
                        //     this.page11.num++;
                        //     this.getShopDetails(392);
                            this.shopInfo = this.shopInfo.concat(arr);
                        // }
                    //this.array.push(this.shopInfo)
                    // console.log(this.shopInfo)
                    // console.log(this.array)
                    //分页
                    this.pageNum = Math.ceil(this.shopInfo.length / this.pageSize) || 1;//计算有多少页数据，默认为1
                    // 循环页面
                    for (let i = 0; i < this.pageNum; i++) {
                    this.totalPage[i] = this.shopInfo.slice(this.pageSize * i, this.pageSize * (i + 1))
                    }
                    // 获取到数据后默认显示第一页内容
                    this.dataShow = this.totalPage[this.currentPage];
                }
                // console.log(this.shopInfo.length)
                for(var i=0;i<this.shopInfo.length;i++){
                    if(this.shopInfo[i].piclink.length > 0){
                        this.shu++;
                        this.shu1 = this.shopInfo.length - this.shu;
                        // console.log(this,shu)
                        // console.log(this,shu1)
                        this.list.push(this.shopInfo[i])
                    }else{
                        this.list1.push(this.shopInfo[i])
                    }
                }
                 //有图分页
                 this.pageNum1 = Math.ceil(this.list.length / this.pageSize1) || 1;//计算有多少页数据，默认为1
                    // 循环页面
                    for (let i = 0; i < this.pageNum1; i++) {
                        this.totalPage1[i] = this.list.slice(this.pageSize1 * i, this.pageSize1 * (i + 1))
                    }
                    // 获取到数据后默认显示第一页内容
                    this.dataShow1 = this.totalPage1[this.currentPage1];

                    //无图分页
                 this.pageNum2 = Math.ceil(this.list1.length / this.pageSize2) || 1;//计算有多少页数据，默认为1
                    // 循环页面
                    for (let i = 0; i < this.pageNum2; i++) {
                        this.totalPage2[i] = this.list1.slice(this.pageSize2 * i, this.pageSize2 * (i + 1))
                        // console.log(this.totalPage2)
                    }
                    // 获取到数据后默认显示第一页内容
                    this.dataShow2 = this.totalPage2[this.currentPage2];
            });
        }
    }
     }
</script>

<style scoped>
     .lang{
        border-bottom:2px solid #e63232;
        color: #e63232;
        position: relative;
        margin-bottom: -2px;
        margin-left: 20px;
    }
    .lang1{
        color: gray;
        position: relative;
        margin-bottom: -2px;
        margin-left: 20px;
    }
    .fen{
        /* border: 1px solid red; */
        text-align: center;
        margin-top: 30px;
    }
    .input1{
        cursor: pointer;
        margin-left: 20px;
        margin-right: 20px;
    }
    .span1{
        cursor: pointer;
        display: inline-block;
        border: 1px solid gray;
        width: 20px;
        height: 20px;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/detail/detail_review.vue